import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import { BookOutlined, BuildOutlined, GlobalOutlined, TeamOutlined } from '@ant-design/icons';
import '../../../Styles/ResearchLabs.css';

const { Paragraph, Title } = Typography;

const researchDomains = [
  {
    title: 'Domain 1 – Theory',
    description: 'This involves the theoretical study of various astrophysical phenomena, with a particular focus on solar physics, the ionosphere, astrophysical plasmas, pulsars, high energy phenomena.',
  },
  {
    title: 'Domain 2 – Computation',
    description: 'This area concerns simulations, data analysis and their implications. Particular areas of focus include the simulations and study of galaxy and supermassive black hole mergers, gravitational wave events, gravitational wave data analysis, high energy astrophysics, gamma-ray bursts, active galactic nuclei, gamma-ray astronomy.',
  },
  {
    title: 'Domain 3 – Observation',
    description: 'The focus of this area is on capacity building in the area of optical observations. Our goals involve studying various objects in the Solar system such as planets near Earth objects, comets, binary stars, variable stars and exoplanets.',
  },
];

const focusedSdgs = [
  { label: 'Quality Education', icon: BookOutlined },
  { label: 'Gender Equality', icon: TeamOutlined },
  { label: 'Partnerships to achieve the Goal', icon: GlobalOutlined },
  { label: 'Industry, Innovation and Infrastructure', icon: BuildOutlined },
];

const SarlDomain = () => (
  <section className="sarl-domains-section">
    <div className="sarl-domains-inner">
      <Row gutter={[72, 44]} justify="space-between">
        <Col xs={24} lg={15}>
          <Title level={2} className="sarl-domains-title">Research Domains</Title>
          <Divider className="ncgsa-divider" />
          <div className="sarl-domain-list">
            {researchDomains.map((domain) => (
              <article className="sarl-domain-item" key={domain.title}>
                <Title level={4}>{domain.title}</Title>
                <Paragraph  className="research-domain-copy">{domain.description}</Paragraph>
              </article>
            ))}
          </div>
        </Col>

        <Col xs={24} lg={8}>
          <Title level={2} className="sarl-domains-title">Focused SDGs</Title>
          <Divider className="ncgsa-divider" />
          <ul className="sarl-sdg-list">
            {focusedSdgs.map(({ label, icon: Icon }) => (
              <li key={label}>
                <span className="sarl-sdg-icon" aria-hidden="true"><Icon /></span>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </div>
  </section>
);

export default SarlDomain;
